<template>
		<div class="checkbox__wrapper">
        <input
                type="radio"
                :checked="modelValue === value"
                :disabled="isDataUpdated"
                :value="value"
                :id="id"
                @change="$emit('update:modelValue', value); $emit('onChange', $event.target.value);"
                v-bind="$attrs"
        >
        <label :for="id">{{ label }}</label>
		</div>
</template>

<script>
export default {
  name: "RadioInput",
  data() {
    return {
    }
  },
  mounted() {
    //this.currentValue = this.value;
  },
  props: [
    'label',
    'modelValue',
    'value',
    'id',
    'isFormSubmitted',
    'isDataUpdated'
  ],
  methods: {}
}
</script>

<style scoped>
label {cursor: pointer}
</style>